const options = (d, a) => {
  return `
    <div class="options">
      <button class="btn-edit">
        <span class="icon"></span>
        <span class="text">Editar</span>
      </button>

      <button class="btn-delete">
        <span class="icon"></span>
        <span class="text">Eliminar</span>
      </button>
    </div>
  `;
};

const vaccine = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}" enctype="multipart/form-data">
      <div class="form-row first">
        <input type="hidden" name="code" value="${d.code}">
        <div class="form-group col">
          <span class="name">Nombre</span>
          <input class="form-control" type="text" name="vacc_name" placeholder="Nombre" value="${
            d.alle_name
          }" disabled>
        </div>

        <div class="form-group col">
          <span class="name">Fecha:</span>
          <input class="form-control datepicker" type="text" name="vacc_reaction" placeholder="Fecha:" value="${
            d.alle_reaction
          }" disabled>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col">
          <span class="name">Adjuntar foto</span>
          <input class="form-control input-img-vacc" type="file" name="vacc_image" placeholder="Subir archivo" value="" disabled>
          <input class="send-vacc-image" type="hidden" name="vacc_image" value="">
          <div id="preview-img-vacc" class="preview-img-vacc" style="display: block">
              <img id="preview-img-vacc" src="${d.image}" alt="">
          </div>
        </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const allergy = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row first">
      <input type="hidden" name="code" value="${d.code}">
        <div class="form-group col">
          <span class="name">Nombre</span>
          <input class="form-control" type="text" name="alle_name" placeholder="Nombre" value="${
            d.alle_name
          }" disabled>
        </div>

        <div class="form-group col">
          <span class="name">Reacción:</span>
          <input class="form-control" type="text" name="alle_reaction" placeholder="Reacción:" value="${
            d.alle_reaction
          }" disabled>
        </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const diseases = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row first">
        <input type="hidden" name="code" value="${d.code}">
        <div class="form-group col">
          <span class="name">Condición</span>
          <input class="form-control" type="text" name="sd_condition" placeholder="Condición" value="${
            d.sd_condition
          }" disabled>
        </div>

        <div class="form-group col">
          <span class="name">Notas:</span>
          <input class="form-control" type="text" name="sd_notes" placeholder="Notas:" value="${
            d.sd_notes
          }" disabled>
        </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const medication = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row">
          <input type="hidden" name="code" value="${d.code}">
          <div class="form-group col">
              <span class="name">Nombre</span>
              <input class="form-control" type="text" name="med_name" placeholder="Nombre" value="${
                d.med_name
              }" disabled>
          </div>

          <div class="form-group col">
              <span class="name">Frecuencia</span>
              <input class="form-control" type="text" name="med_frequency" placeholder="Frecuencia" value="${
                d.med_frequency
              }" disabled>
          </div>

          <div class="form-group col">
              <span class="name">Dosis</span>
              <input class="form-control" type="text" name="med_dose" placeholder="Dosis" value="${
                d.med_dose
              }" disabled>
          </div>
      </div>

      <div class="form-row">
          <div class="form-group col">
              <span class="name">Notas</span>
              <input class="form-control" type="text" name="med_notes" placeholder="Notas" value="${
                d.med_notes
              }" disabled>
          </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const emergencyContact = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row">
          <input type="hidden" name="code" value="${d.code}">
          <div class="form-group col">
              <span class="name">Nombre</span>
              <input class="form-control" type="text" name="ec_name" placeholder="Nombre" value="${
                d.ec_name
              }" disabled>
          </div>

          <div class="form-group col">
              <span class="name">Relación</span>
              <input class="form-control" type="text" name="ec_connection" placeholder="Relación" value="${
                d.ec_connection
              }" disabled>
          </div>

          <div class="form-group col">
              <span class="name">Teléfono</span>
              <input class="form-control" type="text" name="ec_phone" placeholder="Teléfono" value="${
                d.ec_phone
              }" disabled>
          </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const secureInformation = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row first">
          <input type="hidden" name="code" value="${d.code}">
          <div class="form-group col">
              <span class="name">Compañía de seguro</span>
              <input class="form-control" type="text" name="si_company" placeholder="Compañía de seguro" value="${
                d.si_company
              }" disabled>
          </div>

          <div class="form-group col">
              <span class="name">N* de póliza</span>
              <input class="form-control" type="text" name="si_identification_number" placeholder="N* de póliza" value="${
                d.si_identification_number
              }" disabled>
          </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const familyHistory = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row first">
        <input type="hidden" name="code" value="${d.code}">

        <div class="form-group col">
            <span class="name">Parentesco</span>
            <input class="form-control" type="text" name="fh_relationship" placeholder="Parentesco" value="${
              d.fh_relationship
            }" disabled>
        </div>

        <div class="form-group col">
            <span class="name">Condición médica</span>
            <input class="form-control" type="text" name="fh_medical_condition" placeholder="Condición médica" value="${
              d.fh_medical_condition
            }" disabled>
        </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

const additionalInformation = (d, a) => {
  return `<div class="item">
    <form class="form-content" action="${a}">
      <div class="form-row">
          <input type="hidden" name="code" value="${d.code}">
          <div class="form-group col">
              <span class="name">Información:</span>
              <textarea class="form-control" name="adi_report" cols="30" rows="1" placeholder="por ejemplo: órden de no resucitar, testamento, historial médico,etc" disabled>${
                d.adi_report
              }</textarea>
          </div>
      </div>
    </form>

    ${options()}
  </div>`;
};

export {
  vaccine,
  allergy,
  diseases,
  medication,
  emergencyContact,
  secureInformation,
  familyHistory,
  additionalInformation,
};
